export default {
  show_post: 'Show',
  show_posts: 'All',
  load_more: 'Load more',
  back: 'Back',
  language_pl: 'Polish',
  language_en: 'English',
  language_no: 'Norwegian',
  change_language: 'Change language:',
  company_about: 'About the client',
  case_study: 'Case study',
  share_this: 'Share this:',
  caseStudy_button: 'See more',
  article_readTime: "You'll read this article in",
  article_minutes: 'minutes',
  header_menu: 'MENU',
  header_menu_closed: 'CLOSE MENU',
  cookieButton: 'Ok, I accept!',
  cookiesDisabled: 'Zaakceptuj cookie, by strona działała poprawnie',
  articles: 'I want to read about',
  all_categories: 'everything',
  categories: 'Categories',
  cookieNoConsent:
    '<h4>We use cookies</h4><p>We use cookies to personalise content and ads and to improve our site and your experience. You are free to manage this via your browser setting at any time. You can cancel your consent anytime. Canceling your consent will not affect the actions undertaken before doing it.</p>',
  search: 'Search',
  recommended: 'Recommended',
  publication_date: 'Publication date: ',
  learn_more: 'Learn more',
  our_missions: 'Our missions',
  no_results: 'No results.',
  next_slide: 'Next slide',
  prev_slide: 'Previous slide',
  slide_message: 'Go to slide {{index}}',
  ebooks: 'Ebooks',
  webinars: 'Webinars',
  language: 'Select language',
  show_more_case_studies: 'Show more case studies',
  table_of_contents: 'Table of contents',
};
